<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg-img" src="./images/bg.png" alt="" />
      <span class="balance">{{ temporaryBalance }}</span>
      <img class="avatar" :src="avatarUrl" alt="" />
      <div class="lucky-draw-box">
        <LuckyWheel
          ref="luckyDraw"
          :width="luckyDrawConfig.width"
          :height="luckyDrawConfig.height"
          :prizes="luckyDrawConfig.prizes"
          :blocks="luckyDrawConfig.blocks"
          :buttons="luckyDrawConfig.buttons"
          :defaultConfig="luckyDrawConfig.defaultConfig"
          @start="handleStart"
          @end="endLuckDraw"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Login from '@/components/Login/index';
export default {
  name: 'AvatarFrameRocket',
  data() {
    return {
      activityData: {},
      temporaryBalance: 1000,
      costNumber: 300, //單次抽獎需要花費
      drawLoading: false,
      prizeList: ['P06', 'P05', 'P08', 'P03', 'P04', 'P07', 'P02', 'P01'], // 獎品代碼
      drawIndex: 0, // 抽中的獎品所在轉盤位置
      avatarUrl:
        'https://resource.3uplay.com/sys-feed/ce5a5bff-6374-4b23-a4e9-34d84672ec241359903747580901891.webp',
      drawNumber: 1, //抽奖次数
      drawResult: [] //抽奖结果
    };
  },
  computed: {
    ...mapGetters(['accountInfo', 'userInfo']),
    //轉盤設定
    luckyDrawConfig() {
      return {
        width: '789px',
        height: '789px',
        // 背景
        blocks: [
          {
            imgs: [
              {
                src: require('./images/draw-bg.png'),
                width: '100%',
                height: '100%',
                rotate: true
              }
            ]
          }
        ],
        prizes: [{}, {}, {}, {}, {}, {}, {}, {}],
        buttons: [
          {
            radius: '45%',
            imgs: [
              {
                src: this.drawLoading
                  ? require('./images/point-active.png')
                  : require('./images/point.png'),
                width: '60%',
                top: '-84%'
              }
            ]
          }
        ],
        defaultConfig: {
          speed: 10,
          offsetDegree: -360 / 8 / 2,
          accelerationTime: 800,
          decelerationTime: 800
        }
      };
    }
  },
  methods: {
    // 活動結束提醒
    showFinishedDialog() {
      if (true) {
        this.$confirm({
          content:
            '當前活動已結束，更多福利敬請留意nicee平臺，感謝您的支援呀～',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickModal: false
        }).then(() => {
          // this.$router.push({ path: '/' });
        });
      }
    },
    // 獲取詳情
    async getDetail() {
      try {
        const { data } = await this.$http.get(
          '/activity/getActivityLotteryInfo',
          {
            dictType: 'lotteryConf'
          }
        );
        // const data = {
        //   temporaryBalance: 2999
        // };
        this.temporaryBalance = data.temporaryBalance || 0;
        this.activityData = data || {};
        this.showFinishedDialog();
      } catch (error) {
        console.log(error);
      }
    },
    // 檢查登入
    checkLogin() {
      return new Promise(resolve => {
        if (!this.userInfo) {
          Login();
          return;
        } else {
          resolve();
        }
      });
    },
    async handleStart() {
      // this.$refs.luckyDraw.play();
      // setTimeout(() => {
      //   this.$refs.luckyDraw.stop(5);
      //   this.stopDraw('P01')
      // }, 4000);
      if (true) {
        this.showFinishedDialog();
        return;
      }
      if (this.drawLoading) return;
      await this.checkLogin();
      if (this.temporaryBalance >= this.costNumber * 10) {
        this.showDrawNumberDialog();
      } else {
        this.drawNumber = 1;
        this.startLuckDraw();
      }
    },
    showDrawNumberDialog() {
      this.$confirm({
        content: `抽獎需${this.costNumber}個小火箭,十連抽需${this.costNumber *
          10}個小火箭`,
        showCancelButton: true,
        confirmButtonText: '十連抽',
        cancelButtonText: '单抽',
        closeOnClickOverlay: false
      })
        .then(() => {
          this.drawNumber = 10;
          this.startLuckDraw();
        })
        .catch(() => {
          this.drawNumber = 1;
          this.startLuckDraw();
        });
    },
    // 點選抽獎按鈕會觸發start回調
    async startLuckDraw() {
      if (this.temporaryBalance >= this.costNumber * this.drawNumber) {
        this.getDrawResult();
      } else {
        this.$confirm({
          content: `抽獎需${this.costNumber * this.drawNumber}個小火箭`,
          title: '小火箭不足',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true
        });
      }
    },
    // 獲取抽獎結果
    async getDrawResult() {
      this.$refs.luckyDraw.play();
      this.drawLoading = true;
      try {
        const { data } = await this.$http.get('/activity/lottery', {
          dictType: 'lotteryConf',
          count: this.drawNumber
        });
        // const data =
        //   '[{"name":"P08","count":1},{"name":"P07","count":3},{"name":"P06","count":1},{"name":"P05","count":3},{"name":"P04","count":3}]';

        if (data) {
          this.drawResult = JSON.parse(data);
          this.temporaryBalance = this.temporaryBalance - 300 * this.drawNumber;
          this.$store.dispatch('app/getUserAccount');
          this.stopDraw();
        }
      } catch (error) {
        if (error.msg) {
          this.$message(error.msg);
        }
        this.$refs.luckyDraw.stop(0);
        this.drawLoading = false;
      }
    },
    stopDraw() {
      const drawCode =
        this.drawNumber === 1
          ? this.drawResult[0].name
          : this.drawResult[this.drawResult.length - 1].name;
      const drawIndex = this.prizeList.findIndex(item => {
        return item == drawCode;
      });
      // 調用stop停止旋轉並傳遞中獎索引
      this.$refs.luckyDraw.stop(drawIndex);
      this.drawLoading = false;
    },
    endLuckDraw() {
      let drawName = '';
      this.drawResult.forEach(item => {
        const drawIndex = this.prizeList.findIndex(drawCode => {
          return drawCode == item.name;
        });
        switch (drawIndex) {
          case 0:
            drawName = `${drawName}30幣優惠券（滿300減30）*${1 * item.count}<br />`;
            break;
          case 1:
            drawName = `${drawName}666鑽*${1 * item.count}<br />`;
            break;
          case 2:
            drawName = `${drawName}流星飛羽頭像框（1天）*${1 * item.count}<br />`;
            break;
          case 3:
            drawName = `${drawName}環遊太空頭像框（永久）*${1 * item.count}<br />`;
            break;
          case 4:
            drawName = `${drawName}流星飛羽頭像框（永久）*${1 * item.count}<br />`;
            break;
          case 5:
            drawName = `${drawName}流星飛羽頭像框（3天）*${1 * item.count}<br />`;
            break;
          case 6:
            drawName = `${drawName}會員66積分（大）*${1 * item.count}<br />`;
            break;
          case 7:
            drawName = `${drawName}會員33積分（小）*${1 * item.count}<br />`;
            break;
          default:
            break;
        }
      });
      drawName = drawName.slice(0, -1);
      this.$confirm({
        content: `${drawName}`,
        title: '恭喜你抽中了',
        showCancelButton: false,
        confirmButtonText: '確定',
        closeOnClickOverlay: true,
        dangerouslyUseHTMLString: true
      });
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #d3ffff;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg-img {
      width: 100%;
    }
    .balance {
      position: absolute;
      top: 1916px;
      right: 287px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #0f1340;
      font-size: 42px;
      font-style: normal;
      font-weight: 600;
    }
    .lucky-draw-box {
      text-align: left;
      display: block;
      width: 839px;
      position: absolute;
      top: 2054px;
      left: 103px;
    }
    .avatar {
      position: absolute;
      top: 585px;
      left: 350px;
      width: 280px;
      height: 280px;
    }
  }
}
</style>
